import { useMemo } from 'react';
import { AppApiClient } from '../services/api';
import { useRootStore } from './useRootStore';

export const useAppApi = (): AppApiClient => {
    const rootStore = useRootStore();
    return useMemo(() => new AppApiClient(rootStore.brand), [rootStore.brand]);
};
